export const followLinkAttribute = function (el, evt) {
    if (evt.target.closest("a") == null) {
        const url = el.getAttribute("data-link");
        window.location.href = url;
    }
};
